import { MerchantBankEntityService } from '@views/pages/apps/settings/merchant-banks/services/merchant-bank-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';

@Injectable()
export class MerchantBankResolver implements Resolve<boolean> {

    constructor(private merchantBankService: MerchantBankEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.merchantBankService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.merchantBankService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
